import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AssignClass.css";
import {
  obtenerListadoMatriculasAlumnos,
  routeInsertEstudiante,
} from "./constants";

export const AssignClass = () => {
  const [matriculaAlumno, setMatriculaAlumno] = useState("");
  const [matriculaClase, setMatriculaClase] = useState("");
  const [idAlumno, setIdAlumno] = useState("");
  const [clases, setClases] = useState([]);
  const [alumnos, setAlumnos] = useState([]);
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [estaAsignando, setEstaAsignando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const peticionEnProceso = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(obtenerListadoMatriculasAlumnos);
        setClases(response.data.data.matriculas);
        setAlumnos(response.data.data.alumnos);
      } catch (error) {
        console.error("Error al obtener los datos", error);
        setResultado({
          tipo: "error",
          mensaje:
            "No fue posible cargar las clases y los alumnos. Inténtalo de nuevo.",
        });
      } finally {
        setCargandoDatos(false);
      }
    };

    fetchData();
  }, []);

  const handleClaseSeleccionada = (event) => {
    setMatriculaClase(event.target.value);
    setResultado(null);
  };

  const handleAlumnoSeleccionado = (event) => {
    const matriculaSeleccionada = event.target.value;
    setMatriculaAlumno(matriculaSeleccionada);
    setResultado(null);

    const alumno = alumnos.find(
      (item) =>
        `${item.matricula} - ${item.nombre} ${item.apellido}` ===
        matriculaSeleccionada,
    );

    setIdAlumno(alumno ? alumno.id : "");
  };

  const handleSubmitInsertAlumnos = async (event) => {
    event.preventDefault();

    if (peticionEnProceso.current) {
      return;
    }

    const claseValida = clases.some(
      (clase) =>
        `${clase.matricula_clase} - ${clase.nombre_clase}` === matriculaClase,
    );

    if (!idAlumno || !matriculaAlumno || !claseValida) {
      setResultado({
        tipo: "error",
        mensaje: "Selecciona un alumno y una clase válidos de las listas.",
      });
      return;
    }

    peticionEnProceso.current = true;
    setEstaAsignando(true);
    setResultado(null);

    try {
      const response = await axios.post(routeInsertEstudiante, {
        id_alumno: idAlumno,
        matricula_alumno: matriculaAlumno.split(" - ")[0],
        matricula_clase: matriculaClase.split(" - ")[0],
      });

      console.log(response.data);
      setResultado({
        tipo: "exito",
        mensaje:
          response.data?.message || "El alumno fue asignado correctamente.",
      });
      setMatriculaAlumno("");
      setIdAlumno("");
    } catch (error) {
      console.error("Error al insertar alumno en la clase", error);

      if (error.response?.status === 409) {
        setResultado({
          tipo: "advertencia",
          mensaje:
            error.response?.data?.message ||
            "El alumno ya está asignado a esta clase.",
        });
      } else {
        setResultado({
          tipo: "error",
          mensaje:
            error.response?.data?.message ||
            error.response?.data?.error ||
            "No fue posible asignar al alumno. Inténtalo de nuevo.",
        });
      }
    } finally {
      peticionEnProceso.current = false;
      setEstaAsignando(false);
    }
  };

  return (
    <div className="assign-class-page">
      <main className="assign-class-container">
        <header className="assign-class-header">
          <p className="assign-class-eyebrow">Administración académica</p>
          <h1>Asignar alumno a una clase</h1>
          <p>
            Selecciona una clase y un alumno para crear la relación. Las
            asignaciones existentes no se duplicarán.
          </p>
        </header>

        <form
          className="assign-class-form"
          onSubmit={handleSubmitInsertAlumnos}
          noValidate
        >
          <div className="assign-class-grid">
            <section className="assign-class-field-card">
              <div className="assign-class-card-heading">
                <span>1</span>
                <div>
                  <h2>Selecciona la clase</h2>
                  <p>Busca por matrícula o nombre de la clase.</p>
                </div>
              </div>

              <label htmlFor="assign-class-class">Clase</label>
              <input
                id="assign-class-class"
                type="text"
                placeholder={
                  cargandoDatos
                    ? "Cargando clases..."
                    : "Escribe para buscar una clase"
                }
                value={matriculaClase}
                onChange={handleClaseSeleccionada}
                list="clases-list"
                disabled={cargandoDatos || estaAsignando}
                autoComplete="off"
              />
              <datalist id="clases-list">
                {clases.map((clase) => (
                  <option
                    key={clase.id_clase}
                    value={`${clase.matricula_clase} - ${clase.nombre_clase}`}
                  />
                ))}
              </datalist>
            </section>

            <section className="assign-class-field-card">
              <div className="assign-class-card-heading">
                <span>2</span>
                <div>
                  <h2>Selecciona al alumno</h2>
                  <p>Busca por matrícula o nombre del estudiante.</p>
                </div>
              </div>

              <label htmlFor="assign-class-student">Alumno</label>
              <input
                id="assign-class-student"
                type="text"
                placeholder={
                  cargandoDatos
                    ? "Cargando alumnos..."
                    : "Escribe para buscar un alumno"
                }
                value={matriculaAlumno}
                onChange={handleAlumnoSeleccionado}
                list="alumnos-list"
                disabled={cargandoDatos || estaAsignando}
                autoComplete="off"
              />
              <datalist id="alumnos-list">
                {alumnos.map((alumno) => (
                  <option
                    key={alumno.id}
                    value={`${alumno.matricula} - ${alumno.nombre} ${alumno.apellido}`}
                  />
                ))}
              </datalist>
            </section>
          </div>

          {resultado && (
            <div
              className={`assign-class-result assign-class-result-${resultado.tipo}`}
              role="status"
              aria-live="polite"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="assign-class-actions">
            <button
              type="submit"
              disabled={
                cargandoDatos ||
                estaAsignando ||
                !matriculaClase ||
                !matriculaAlumno
              }
            >
              {estaAsignando ? "Asignando alumno..." : "Asignar alumno"}
            </button>
            <button
              type="button"
              className="assign-class-secondary"
              onClick={() => navigate("/admin-home")}
              disabled={estaAsignando}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};
